import { render, staticRenderFns } from "./AddEditFaculty.vue?vue&type=template&id=7fe99b46"
import script from "./AddEditFaculty.vue?vue&type=script&lang=js"
export * from "./AddEditFaculty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports